<template>
  <div>
    <div
      class="product-middle-item fadeInUp animated"
      v-for="(item, index) in data"
      :key="index"
      :style="{ animationDelay: +(index + 1) * 0.2 + 's' }"
    >
      <div class="product-middle-item-img">
        <img :src="item.path" alt />
        <p>{{ item.name }}</p>
      </div>
      <span>{{ item.detail }}</span>
    </div>
    <!-- <div class="product-middle-item">
      <div class="product-middle-item-img">
        <img src="../../assets/image/home41.png" alt />
        <p>02.数据获取</p>
      </div>
      <span>强大的行为数据获取能力</span>
    </div>
    <div class="product-middle-item">
      <div class="product-middle-item-img">
        <img src="../../assets/image/home41.png" alt />
        <p>03.智能分析</p>
      </div>
      <span>深入的行为数据分析，构建行为模型</span>
    </div>
    <div class="product-middle-item">
      <div class="product-middle-item-img">
        <img src="../../assets/image/home41.png" alt />
        <p>04.行为可视化</p>
      </div>
      <span>多维度行为数据分析后做数据可视化</span>
    </div>-->
  </div>
</template>
<script>
export default {
  props: ["data"],
};
</script>
<style lang="scss" scoped>
.product-middle-item {
  display: inline-block;
  width: 285px;
  float: left;
  text-align: center;
  cursor: pointer;
  .product-middle-item-img {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      height: 220px;
    }
    p {
      position: absolute;
      bottom: -16px;
      left: 47.5px;
      width: 190px;
      height: 32px;
      font-size: 18px;
      text-align: center;
      line-height: 32px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      background: rgba(255, 106, 0, 1);
      box-shadow: 0px 4px 13px 0px rgba(151, 170, 182, 0.31);
    }
  }
  span {
    display: inline-block;
    margin-top: 32px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(52, 52, 55, 1);
    line-height: 21px;
    padding: 0 50px;
  }
  & + .product-middle-item {
    margin-left: 20px;
  }
  &:hover {
    .product-middle-item-img {
      p {
        left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/product.vue